<template>
  <div class="flex flex-col items-center min-h-full">
    <AppHeader />
    <main
      class="flex flex-col items-center  flex-grow w-full h-full min-h-full pb-6 text-center bg-dark-100 dark:bg-dark-800"
    >
      <h1 class="px-4 py-5 text-4xl font-semibold text-center font-heading">
        Lockdown Orienteering  - View Routes
      </h1>

      <div
        class="inline-block w-10/12 px-6 py-3 my-4 text-center bg-white rounded-lg shadow-lg md:w-3/4 lg:w-2/3 dark:bg-dark-600"
      >
        <label for="id" class="block p-2 text-xl font-semibold font-heading"
          >Race Number:</label
        >
        <input
          v-model.number="id"
          name="id"
          type="number"
          class="inline-block w-1/2 px-4 py-2 my-2 text-xl text-center bg-transparent border-2 rounded outline-none border-purple-light focus:border-purple dark:text-white"
          required
        />
        <h2
          v-if="error"
          class="mt-4 mb-2 text-2xl font-heading text-purple-darkest dark:text-white"
        >
          A Competitor with that Race Number Was Not Found. Please Try Again
        </h2>

        <div>
          <button class="mt-4 mb-2 button" @click="lookupCompetitor">
            <template v-if="!loading">
              View Routes
            </template>
            <template v-else>
              Loading
            </template>
          </button>
        </div>
      </div>
      <div
        v-if="competitor && competitor.paths && competitor.paths.length > 0"
        class="grid w-10/12 grid-cols-1 gap-8 my-8 align-top mx-1/12 xl:grid-cols-2"
      >
        <div v-for="leg of course.legs" :key="course.legs.indexOf(leg)">
          <div
            class="flex flex-col items-center px-6 pb-3 bg-white rounded-lg shadow-lg dark:bg-dark-600"
          >
            <h2 class="py-4 text-3xl font-semibold font-heading">
              Leg {{ course.legs.indexOf(leg) + 1 }}
            </h2>
            <ViewRoute
              :settings="leg"
              :userPath="competitor.paths[course.legs.indexOf(leg)]"
              :number="course.legs.indexOf(leg)"
            />
          </div>
        </div>
      </div>
    </main>
    <AppFooter />
  </div>
</template>
<script>
import AppHeader from '@/components/AppHeader'
import AppFooter from '@/components/AppFooter'
import ViewRoute from '@/components/ViewRoute'

import Course from '@/assets/LockdownCourse'

export default {
  components: {
    AppHeader,
    AppFooter,
    ViewRoute,
  },

  data: () => ({
    course: Course,

    id: '',
    competitor: {},

    loading: false,
    error: false,
  }),

  methods: {
    lookupCompetitor: async function () {
      this.loading = true
      this.error = false
      this.noPaths = false
      this.competitor = {}

      this.competitor = await fetch(
        `/api/lookupCompetitor?raceNumber=${this.id}`
      ).then((response) => response.json())

      if (this.competitor.raceNumber !== this.id || !this.competitor.success)
        this.error = true

      try {
        this.competitor.paths = JSON.parse(this.competitor.paths)
      } catch {
        this.competitor.paths = undefined
      }

      this.loading = false
    },
  },
}
</script>
<style>
div {
  transition: 0.5s;
}
</style>
